import React from 'react'
import PropTypes from 'prop-types'

import './styles.css'

const Slideshow = ({slides, id}) => {
    return (
        <div id={id} className="carousel slideshow slide carousel-fade" data-ride="carousel">
            <ol className="carousel-indicators">
                {slides.map((slide,index) => {
                    return <li data-target={`#${id}`} data-slide-to={index} className={index==0?'active':''}></li>
                })}
            </ol>
            <div className="carousel-inner">
                {slides.map((slide,index) => {
                    return (
                        <div className={`carousel-item ${index===0?'active':''}`} style={{backgroundImage: `url(${slide.image})`}}>
                            <div>
                                <h1 className="display-4">{slide.text.split('|')[0]}</h1>
                                <p className="lead">{slide.text.split('|')[1]}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <a className="carousel-control-prev" href={`#${id}`} role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href={`#${id}`} role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
            </a>
        </div>
    )
}

Slideshow.propTypes = {
    id: PropTypes.string.isRequired,
    slides: PropTypes.array.isRequired
}

export default Slideshow



// WEBPACK FOOTER //
// ./src/components/Slideshow/index.jsx